import React, { useState, useEffect, useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import './style.css';
import { Badge, Button, Card, CardBody, CardHeader, Col, Pagination, PaginationItem, PaginationLink, Popover, PopoverBody, Row, Spinner } from 'reactstrap';
import { FaAngleDoubleLeft, FaAngleDoubleRight, FaAngleLeft, FaAngleRight, FaEdit, FaEllipsisH, FaPlus, FaSearch } from 'react-icons/fa';
import { useTranslation } from 'react-i18next';
import Swal from 'sweetalert2';
import { debounce } from 'lodash';
import { format, parse } from 'date-fns';
import { invoiceSupplierActions } from '../../sagas/invoiceSupplierSlice';
import ClientPaymentModal from './ClientPaymentModal';
import { formatPrice } from '../../helpers/utility';
import { useLocation } from 'react-router-dom';

const ClientPaimentsList = () => {
    const dispatch = useDispatch();
    const { payments,
        totalPages,
        totalElements,
        totalAmountTtc,
        dateFrom,
        dateTo,
        pageSize, loading } = useSelector((state) => state.invoiceSupplier);
    const [filter, setFilter] = useState('');
    const { company } = useSelector(state => state.auth);
    const [showModal, setShowModal] = useState(false);
    const { t } = useTranslation();
    const [currentPage, setCurrentPage] = useState(1);
    const location = useLocation();
    const [selectedPurchase, setSelectedPurchase] = useState(null);
    const [popoverOpen, setPopoverOpen] = useState(false);
    const [criteria, setSearchCriteria] = useState({ query: '' });
    const [isSearching, setIsSearching] = useState(false);
    const [selectedPayment, setSelectedPayment] = useState(null);

    const formatDateForInput = (dateString) => {
        if (!dateString) return '';
        return format(parse(dateString, "dd/MM/yyyy", new Date()), "yyyy-MM-dd");
    };

    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    // Convert input date format (yyyy-MM-dd) to backend date format (dd/MM/yyyy)
    const formatDateForBackend = (dateString) => {
        if (!dateString) return '';
        const parsedDate = parse(dateString, 'yyyy-MM-dd', new Date());
        return format(parsedDate, 'dd/MM/yyyy');
    };

    const handleShowPayment = (payment) => {
        setSelectedPayment(payment);
        setPopoverOpen(!popoverOpen);
    };
    useEffect(() => {
        let payload = {
            criteria: criteria,
            page: currentPage,
            size: pageSize,
        };
        dispatch(invoiceSupplierActions.fetchPayments(payload));

    }, [currentPage, criteria, dispatch]);

    const handleShowPaymentModal = (purchase) => {
        setPopoverOpen(false);
    };

    const handleClosePaymentModal = () => {
        setSelectedPayment(null);
    };

    const handleDateFilter = () => {
        dispatch(invoiceSupplierActions.fetchPayments({
            startDate: formatDateForBackend(startDate),
            endDate: formatDateForBackend(endDate)
        }));
    };

    const debouncedSearch = useCallback(
        debounce((query) => {
            setIsSearching(true);
            dispatch(invoiceSupplierActions.fetchPayments({
                criteria: { query },
                page: 1,
                size: pageSize,
                onSuccess: () => setIsSearching(false)
            }));
        }, 500), // Wait 500ms after last keystroke
        []
    );

    const handleFilterChange = (e) => {
        const value = e.target.value;
        setFilter(value);
        debouncedSearch(value);
    };

    const refrechPayments = () => {
        let payload = {
            criteria,
            page: currentPage,
            size: pageSize,
        };
        dispatch(invoiceSupplierActions.fetchPayments(payload));
    }

    const handleGeneratePdf = (order) => {
       
    };

    const handleDeletePayment = (id) => {
        setPopoverOpen(!popoverOpen)
        Swal.fire({
            title: 'Êtes-vous sûr?',
            text: "Voulez-vous vraiment supprimer cette facture?",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Oui, supprimer!',
            cancelButtonText: 'Annuler'
        }).then((result) => {
            if (result.isConfirmed) {
                dispatch(invoiceSupplierActions.deletePayment({
                    id: id, onSuccess: () => {
                        Swal.fire({
                            icon: 'success',
                            title: 'Supprimé!',
                            text: 'La facture a été supprimée.',
                            showConfirmButton: false,
                            timer: 1500
                        });
                        refrechPayments();
                    }
                }));
            }
        });
    };    const handleShowModal = () => {
        setShowModal(true);
    };

    const handleCloseModal = () => {
        setShowModal(false);
        refrechPayments();
    };
    const handlePageChange = (newPage) => {
        setCurrentPage(newPage);
    };

    const handleToggleActions = (payment) => {
        setSelectedPayment(payment);
        setPopoverOpen(!popoverOpen);
    };

    const getStatusBadge = (status) => {
        switch (status) {
            case 'DRAFT':
                return <Badge color="secondary">Brouillon</Badge>;
            case 'ORDERED':
                return <Badge color="info">Commandé</Badge>;
            case 'RECEIVED':
                return <Badge color="primary">Reçu</Badge>;
            case 'INVOICED':
                return <Badge color="warning">Facturé</Badge>;
            case 'PAID':
                return <Badge color="success">Payé</Badge>;
            case 'CANCELED':
                return <Badge color="danger">Annulé</Badge>;
            default:
                return <Badge color="light">-</Badge>;
        }
    };

    useEffect(() => {
        if (dateFrom != null) {
            setStartDate(formatDateForInput(dateFrom));
        }

        if (dateTo != null) {
            setEndDate(formatDateForInput(dateTo))
        }

    }, [dateFrom, dateTo])


    if (loading) {
        return (
            <div
                style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    right: 0,
                    bottom: 0,
                    backgroundColor: 'rgba(0,0,0,0.3)',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    zIndex: 9999,
                }}
            >
                <Spinner color="primary" />
            </div>
        );
    }

    return (
        <div className="purchase-list-container">
            <Card>
                <CardHeader className="d-flex justify-content-between align-items-center">
                    <h2>{t('payment.title')}</h2>
                    <Button color="primary" onClick={handleShowModal}>
                        <FaPlus className="mr-2" /> {t('payment.newPayment')}
                    </Button>
                </CardHeader>
                <CardBody>
                    <div className="filter-container mb-3">
                        <Row>
                            {/* Search Field */}
                            <Col md={5}>
                                <input
                                    type="text"
                                    placeholder="Filtrer par N° commande ou forunisseur"
                                    value={filter}
                                    onChange={handleFilterChange}
                                    className="form-control"
                                />
                            </Col>

                            {/* Date From Field */}
                            <Col md={3}>
                                <input
                                    type="date"
                                    value={startDate}
                                    onChange={(e) => setStartDate(e.target.value)}
                                    className="form-control"
                                    placeholder={t('purchase.dateFrom')}
                                />
                            </Col>

                            {/* Date To Field */}
                            <Col md={3}>
                                <input
                                    type="date"
                                    value={endDate}
                                    onChange={(e) => setEndDate(e.target.value)}
                                    className="form-control"
                                    placeholder={t('purchase.dateTo')}
                                />
                            </Col>

                            {/* Filter Button */}
                            <Col md={1}>
                                <Button color="primary" onClick={handleDateFilter} size="sm">
                                    <FaSearch /> {t('purchase.filter')}
                                </Button>
                            </Col>
                        </Row>
                    </div>
                    <table className="table table-hover table-striped">
                        <thead className="thead-light">
                            <tr>
                                <th className="align-middle text-center">{t('payment.payNumber')}</th>
                                <th className="align-middle text-center">{t('payment.supplier')}</th>
                                <th className="align-middle text-center">{t('payment.paymentDate')}</th>
                                <th className="align-middle text-center">{t('payment.amount')}</th>
                                <th className="align-middle text-center">{t('payment.paymentMode')}</th>
                                <th className="align-middle text-center">{t('payment.invoiceNumber')}</th>
                                <th className="align-middle text-center">{t('payment.actions')}</th>
                            </tr>
                        </thead>
                        <tbody>
                            {payments?.length === 0 && (
                                <tr>
                                    <td colSpan="7" className="text-center text-muted">
                                        {t('payment.noPaymentsFound')}
                                    </td>
                                </tr>
                            )}
                            {payments?.map((payment) => (
                                <tr key={payment.id}>
                                    <td className="align-middle text-center">{payment.numero}</td>
                                    <td className="align-middle text-center">{payment?.supplierBusinessName}</td>
                                    <td className="align-middle text-center">{new Date(payment.paymentDate).toLocaleDateString()}</td>
                                    <td className="align-middle text-center">{formatPrice(payment.amount)}</td>
                                    <td className="align-middle text-center">{payment.paymentMethod}</td>
                                    <td className="align-middle text-center">{payment.invoiceNumero ?? ''}</td>
                                    <td className="align-middle text-center">
                                        <span
                                            id={`Popover-${payment.id}`}
                                            title='Afficher les actions'
                                            onClick={() => handleToggleActions(payment)}
                                            className="me-1 px-2 py-1"
                                            style={{ cursor: 'pointer' }}
                                        >
                                            <FaEllipsisH size={12} className="mr-2" />
                                        </span>
                                        <Popover
                                            placement="bottom"
                                            isOpen={popoverOpen && selectedPayment && selectedPayment.id === payment.id}
                                            target={`Popover-${payment.id}`}
                                            toggle={() => setPopoverOpen(!popoverOpen)}
                                        >
                                            <PopoverBody>
                                                {/* <Button color="secondary" title='Téléchargé PDF' onClick={() => handleGeneratePdf(purchase)} size="sm" className="me-1 px-2 py-1">
                                                    <FaFilePdf size={12} className="mr-2" />
                                                </Button>

                                                <Button color="danger" title='Supprimer' onClick={() => handleDeleteOrder(purchase.id)} size="sm" className="me-1 px-2 py-1">
                                                    <FaTrash size={12} className="mr-2" />
                                                </Button> */}

                                                <Button color="warning" title='Modifier' onClick={() => handleShowPayment(payment)} size="sm" className="px-2 py-1">
                                                    <FaEdit size={12} className="mr-2" />
                                                </Button>
                                            </PopoverBody>
                                        </Popover>
                                    </td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                    <div className="d-flex justify-content-between align-items-center mt-3">
                        <small className="text-muted">
                            {t('product.showing', {
                                start: (currentPage - 1) * pageSize + 1,
                                end: Math.min(currentPage * pageSize, totalElements),
                                total: totalElements,
                                currentPage: currentPage,
                                totalPages: totalElements
                            })}
                        </small>
                        <Pagination size="sm" className="mb-0">
                            <PaginationItem disabled={currentPage === 1}>
                                <PaginationLink first onClick={() => handlePageChange(1)}>
                                    <FaAngleDoubleLeft size={12} />
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === 1}>
                                <PaginationLink previous onClick={() => handlePageChange(currentPage - 1)}>
                                    <FaAngleLeft size={12} />
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === totalPages}>
                                <PaginationLink next onClick={() => handlePageChange(currentPage + 1)}>
                                    <FaAngleRight size={12} />
                                </PaginationLink>
                            </PaginationItem>
                            <PaginationItem disabled={currentPage === totalPages}>
                                <PaginationLink last onClick={() => handlePageChange(totalPages)}>
                                    <FaAngleDoubleRight size={12} />
                                </PaginationLink>
                            </PaginationItem>
                        </Pagination>
                    </div>
                    <div className="mt-4">
                        <Card className="shadow-sm border-0">
                            <CardBody className="d-flex justify-content-between align-items-center">

                                <div className="text-success">
                                    <h5 className="mb-1">{t('payment.totalAmount')}</h5>
                                    <h4 className="fw-bold">{formatPrice(totalAmountTtc)}</h4>
                                </div>
                            </CardBody>
                        </Card>
                    </div>                </CardBody>
            </Card>

            {/* Client Payment Modal */}
            <ClientPaymentModal 
                isOpen={showModal}
                toggle={handleCloseModal}
                onSuccess={refrechPayments}
            />
        </div>
    );
};

export default ClientPaimentsList;